import Vue                      from "vue";
import { mapGetters }           from "vuex";
import { 
  formatDateTime, 
  stringHelper,
  sizeHelper,
  partInfoHelper
}                               from "@/components/mixins";
import { 
  LoadingSpinner,
  DnFunctionButton 
}       from "@/components/Elements"
import CurrencyText             from "@/components/Elements/CurrencyText.vue";
import DnNumberInput            from "@/components/Elements/DnNumberInput.vue"
import PartRequestQuote         from "@/components/PartRequestQuote/PartRequestQuote.vue"
import vSelect                  from "vue-select"

// icons
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";


export default Vue.extend({
  name: "PartInfo",
  components: {
    FontAwesomeIcon,
    vSelect,
    LoadingSpinner,
    CurrencyText,
    DnNumberInput,
    DnFunctionButton,
    PartRequestQuote
  },
  mixins: [formatDateTime, stringHelper, sizeHelper,partInfoHelper], 
   computed: {
      ...mapGetters([
        "collapseAllPartDescriptionsValue",
      ]),
    }, 
  data: () => ({
    downChevronIcon: faChevronDown,
    upChevronIcon: faChevronUp,
  }),
  watch: {
    collapseAllPartDescriptionsValue(newValue) {
      this.collapsePartDescription = newValue;
    }
  },
  created() {
    this.collapsePartDescription = this.collapseAllPartDescriptionsValue
  },
  methods: {
  swapIcon() {
    if (this.collapsePartDescription) {
      this.collapsePartDescription = false;
      this.icon = "upChevronIcon";
    } else {
      this.collapsePartDescription = true;
      this.icon = "downChevronIcon";
    }
  }
  },
});
